import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  raffles: [],
};

const rafflesSlice = createSlice({
  name: "raffles",
  initialState,
  reducers: {
    setRaffles(state, action) {
      state.raffles = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRaffles } = rafflesSlice.actions;
export default rafflesSlice.reducer;
